import { useEffect, useState } from "react";
import { useStore } from "../../../store";
// Components
import OrderDetails from "../OrderDetails/OrderDetails";
import StripeCardForm from "../StripeCardForm/StripeCardForm";
// Styles
import styles from "./CheckoutContent.module.scss";

const CheckoutContent = () => {
  const { chosenPackage, fieldRoutesCustomer } = useStore();

  const [mapsLoaded, setMapsLoaded] = useState(false);

  useEffect(() => {
    const scriptTag = document.createElement("script");
    scriptTag.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places&language=en`;
    scriptTag.addEventListener("load", () => setMapsLoaded(true));
    document.body.appendChild(scriptTag);
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.checkoutSection}>
        <h1 className={styles.title}>Checkout</h1>
      </div>

      <div className={styles.content}>
        <div className={styles.cardSection}>
          {mapsLoaded && <StripeCardForm />}
        </div>

        <div className={styles.orderSection}>
          <OrderDetails
            chosenPackage={chosenPackage}
            fieldRoutesCustomer={fieldRoutesCustomer}
          />
        </div>
      </div>
    </div>
  );
};

export default CheckoutContent;
